<script lang="ts">
    
    import { onDestroy, onMount } from "svelte";
    import { makeTimeString } from "../Services/Helpers";

    let clockInterval: number;
    let clockString: string = '00:00';

    export let from: Date;

    onMount(() => clockInterval = window.setInterval(updateClock, 1000));
    onDestroy(() => window.clearInterval(clockInterval));

    function updateClock() {
        clockString = makeTimeString((Date.now() - from.getTime()) / 1000);
    }

</script>

<style lang="scss">

    .clock {
        display: flex;
        align-items: center;
    }

    .crono {
        width: 1rem;
        height: 1rem;
        object-fit: contain;
        margin-right: 0.25rem;
    }

</style>

<div class="clock">
    <img class="crono" src="/images/icon-crono.png" alt=""> {clockString}
</div>